import { render } from "./StockUniverse.vue?vue&type=template&id=4b9b9f38"
import script from "./StockUniverse.vue?vue&type=script&lang=js"
export * from "./StockUniverse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__